import { EbookPage } from './EbookPage'
import { withEbookPage } from './withEbookPage'

const ConnectedEbookPage = withEbookPage(EbookPage)

export { ConnectedEbookPage as EbookPage }
